var React = require('react');

function ArrowIconWithMarginInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"#arrow .cls-1{fill:none;stroke:#90a4b0;stroke-miterlimit:10;stroke-width:3.4px;}")),React.createElement("polyline",{"className":"cls-1","points":"41.48 52.09 24.32 34.92 41.48 17.76","key":1})]);
}

ArrowIconWithMarginInline.defaultProps = {"id":"arrow","data-name":"Layer 1","viewBox":"0 0 69.85 69.85"};

module.exports = ArrowIconWithMarginInline;

ArrowIconWithMarginInline.default = ArrowIconWithMarginInline;
